jQuery(function ($) {
  $('.js-staff-modal-open').on('click', function (e) {
    const target = $('.staff__modal');
    e.preventDefault();
    if ($(this).data('form-value')) {
      $('#preferred-staff').val($(this).data('form-value'));
    }
    target.show();
    bodyScrollLock?.disableBodyScroll(target);
  });

  // close modal
  $('.js-close-staff-modal').on('click', function (e) {
    e.preventDefault();
    $('.staff__modal').hide();
    $('.staff__modal').removeClass('staff__modal--form-sent');
    bodyScrollLock?.clearAllBodyScrollLocks();
  });
  // close modal on overlay click
  $('html').on('click', function (e) {
    // check if the click is on the modal overlay
    if ($(e.target).hasClass('staff__modal__overlay')) {
      $('.staff__modal').hide();
      $('.staff__modal').removeClass('staff__modal--form-sent');
      bodyScrollLock?.clearAllBodyScrollLocks();
    }
  });
});
